import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  Output,
  inject,
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

import { Observable, of } from 'rxjs'

import {
  FLX_MODAL_DATA,
  FlxButtonModule,
  FlxModalModule,
  FlxModalService,
} from '@flowx/angular-ui-toolkit'
import {
  DataModelAttribute,
  DataModelTypeEntity,
} from '@flowx/designer/modules/core/dictionary/data-model.dictionary'
import { ResourceUsagesDeleteConfirmationComponent } from '@flowx/designer/shared/components/resource-usages/resource-usages-delete-confirmation.component'
import { ResourceUsagesComponent } from '@flowx/designer/shared/components/resource-usages/resource-usages.component'
import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'
import {
  ResourceUsage,
  ResourceUsageReferencesGroupingConfig,
  ResourceUsageReferencesGroupingType,
} from '@flowx/designer/shared/model/resource-usage.model'
import { ResourceUsagesService } from '@flowx/designer/shared/services/resource-usages.service'

@Component({
  selector: 'flx-data-action-type-confirmation-modal',
  imports: [FlxButtonModule, FlxModalModule, ResourceUsagesDeleteConfirmationComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './data-type-action-confirmation-modal.component.html',
})
export class DataTypeActionConfirmationModalComponent {
  #modalService = inject(FlxModalService)
  #resourceUsagesService = inject(ResourceUsagesService)
  #destroyRef = inject(DestroyRef)

  @Output() dataEventEmitter = new EventEmitter<{ dataType: DataModelTypeEntity }>()

  data = inject<{
    dataType: DataModelTypeEntity
    resourceUsages?: ResourceUsage[]
    attribute?: DataModelAttribute
    action?: string
  }>(FLX_MODAL_DATA)
  ApplicationResourceType = ApplicationResourceType

  openResourceUsagesModal(
    dataType: DataModelTypeEntity,
    source: 'rowAction' | 'pageAction' | 'fromDeleteConfirm' = 'fromDeleteConfirm',
    resourceUsages?: ResourceUsage[]
  ): void {
    let endpoint: Observable<ResourceUsage[]>

    if (!resourceUsages) {
      endpoint = this.#resourceUsagesService.getResourceUsages(dataType.resourceId)
    } else {
      endpoint = of(resourceUsages)
    }

    endpoint.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((resourceUsages) => {
      const referencesGroupingConfig = {
        type: ResourceUsageReferencesGroupingType.MULTIPLE,
        groupBy: 'targetElementId',
      } satisfies ResourceUsageReferencesGroupingConfig

      this.#modalService.show(
        ResourceUsagesComponent,
        {},
        {
          name: dataType.name,
          resourceType: ApplicationResourceType.ProjectDataType,
          referencesGroupingConfig,
          resourceUsages,
          source,
        }
      )
    })
  }
  closeModal(): void {
    this.#modalService.hide()
  }

  confirm(): void {
    this.closeModal()
    this.dataEventEmitter.emit({ dataType: this.data.dataType })
  }
}
